import { forwardRef } from "react";

import { clsx } from "clsx";

import styles from "./styles.module.scss";
import { ClockOutline } from "assets/icons";
import { ReactComponent as LinkIconComponent } from "assets/icons/link.svg";
import { getDecodedURL, getDomainFromUrl } from "utils/url";
import useTranslation from "hooks/useTranslation";
import { replaceKeyWithValue } from "utils/text";
import { getElapsedTime } from "utils/date";

const TimeSpentCard = forwardRef(function TimeSpentCard(
  { id, data, isLastCard, locale },
  ref
) {
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  const getTextFromDiffsObject = (diffs) => {
    const { hours, minutes, seconds } = diffs;
    const phrases = [];

    // add to phrases if the value is not zero and join them to show as a text
    if (hours)
      phrases.push(replaceKeyWithValue(t("HOURS"), "hour", hours).join(""));

    if (minutes)
      phrases.push(
        replaceKeyWithValue(t("MINUTES"), "minute", minutes).join("")
      );

    if (seconds)
      phrases.push(
        replaceKeyWithValue(t("SECONDS"), "second", seconds).join("")
      );

    return phrases.join(t("ROADMAP_MODAL").AND);
  };

  const startDate = new Date(data.start);
  const endDate = data.end ? new Date(data.end) : new Date();
  const timeSpent = getTextFromDiffsObject(getElapsedTime(startDate, endDate));

  const timeSpentText = replaceKeyWithValue(
    t("ROADMAP_MODAL").TIME_SPENT,
    "time",
    timeSpent
  ).join("");

  return (
    <div className={styles.time_card__wrapper} data-islast={isLastCard}>
      <div
        ref={(el) => {
          ref.current[id] = el;
        }}
        className={clsx([styles.time_card, isLastCard && styles.last_card])}
      >
        {/* head */}
        <div className={styles.time_card__head}>
          <a
            className={styles.time_card__url}
            target="_blank"
            rel="noreferrer"
            href={data.url}
            title={data.url}
          >
            {getDomainFromUrl(getDecodedURL(getDecodedURL(data.url)))}
          </a>
          <LinkIconComponent className={styles.time_card__link_icon} />
        </div>

        {/* time */}
        <div className={styles.time_card__time_spent}>
          <img
            className={styles.time_card__time_icon}
            src={ClockOutline}
            alt="clock"
          />
          <span title={timeSpentText} className={styles.time_card__text}>
            {timeSpentText}
          </span>
        </div>

        {/* card num  */}
        <div className={styles.time_card__time_num}>{id}</div>
      </div>
    </div>
  );
});

export default TimeSpentCard;
